import { EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { createActionGroup, createFeature, createReducer, createSelector, emptyProps, on, props } from "@ngrx/store";
import { AuthUser } from "./../../../globalTypes/auth.types";

export interface AuthUserState {
  isLoading: boolean;
  user: AuthUser | null;
}

const adapter: EntityAdapter<AuthUser> = createEntityAdapter<AuthUser>();

export const AuthUserActions = createActionGroup({
  source: 'AUTHUSER',
  events: {
    'Is Loading': props<{ isLoading: boolean }>(),
    'Set User': props<{ user: AuthUser | null }>(),
    'Set Default Location': props<{ locationId: string }>(),
    'Log Out': emptyProps(),
    'Set Is Verified For Segment': props<{ segmentId: number, isVerified: boolean }>(),
  }
});

const initialAuthUserState: AuthUserState = {
  isLoading: true,
  user: null,
}

const authUserReducer = createReducer(
  initialAuthUserState,
  on(AuthUserActions.isLoading, (state, { isLoading }) => ({ ...state, isLoading })),
  on(AuthUserActions.setUser, (state, action) => ({ ...state, user: action.user, isLoading: false })),
  on(AuthUserActions.setDefaultLocation, (state, action) => {
      if(!state.user) return state;
      return {...state, user: {...state.user, defaultLocationId: action.locationId}, isLoading: false }
    }),
  on(AuthUserActions.setIsVerifiedForSegment, (state, action) => {
      if(!state.user) return state;
      const isVerifiedForSegment = {...state.user.isVerifiedForSegment, [action.segmentId]: action.isVerified};
      return {...state, user: {...state.user, isVerifiedForSegment}, isLoading: false }
    }),
  on(AuthUserActions.logOut, (state) => ({...state, user: null, isLoading: false})),
)

export const authUserFeature = createFeature({
  name: 'authUser',
  reducer: authUserReducer,
  extraSelectors: ({selectUser}) => ({
    selectPreferences: createSelector(selectUser, (user) => ({uid: user?.id, preferences: user?.preferences || {}})),
    selectSavedSearches: createSelector(selectUser, (user) => user?.preferences.savedSearches || []),
  })
})

